module.exports = __webpack_public_path__ + "static/media/0601.cc9c58c0.png";